import { useContext, useEffect, useState } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  Box, Button, FormControl, FormLabel, Input,
  FormErrorMessage, VStack, Stack, Text, Link, Flex, Avatar
} from '@chakra-ui/react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import UserService from "../services/UserService";

// Validation Schema
const schema = Yup.object().shape({
  MobileNo: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  password: Yup.string()
    .min(4, "Password must be at least 4 characters")
    .required("Password is required"),
});

const AdminLogin = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(0);
  const [CompCd, setCompCd] = useState(0);
  const [otp, setOTP] = useState("");
  const [otpErrors, setotpErrors] = useState("");
  const [showBlock, setShowBlock] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setMobile(data.MobileNo)
    setPassword(data.password)
    setRole(5)
    setCompCd(1)
    try {
      const res = await login(data.MobileNo, data.password, 5, 1);

      if (res.role > 0) {
        setShowBlock(true)
      }
    } catch (error) {
      if (error.response?.status === 401) {
        alert(error.response.data.message);
      } else {
        alert("Something went wrong. Please try again.");
        console.error(error);
      }
    }

  };

  const handleOTP = async (e) => {
    e.preventDefault();
    setotpErrors(null)
    if (otp) {
      let params = {
        MobileNo: mobile, Password: password, otp: otp, role: role, CompCd:CompCd
      };

      try {
        const res = await UserService.verifyLoginOTP(params);
        const user = JSON.parse(localStorage.getItem("user"));

        user.PassengerId = 0;
        user.ReqNo = 0;
        user.DriveNo = 0;
        user.DriverId = 0;

        localStorage.setItem("user", JSON.stringify(user));

        if (res.role === 5) {
          navigate("/admin");
        } else if (res.role === 1) {
          navigate("/driver/map");
        } else if (res.role === 2) {
          navigate("/user/map");
        } else {
          alert("Invalid credentials");
        }

      } catch (error) {
        if (error.response?.status === 401) {
          alert(error.response.data.message);
          // setotpErrors(error.response.data.message)
        } else {
          alert("Something went wrong. Please try again.");
          console.error(error);
        }
      }
    }
  };

  const resendOTP = async () => {
    if (mobile) {
      let params = {
        MobileNo: mobile
      };

      try {
        const res = await UserService.sendOTP(params);
        if (res.statusCode === 200) {
          alert(res.message);
        }
      } catch (error) {
        if (error.response?.status === 401) {
          alert(error.response.data.message);
        } else {
          alert("Something went wrong. Please try again.");
          console.error(error);
        }
      }
    }
  }

  return (

    <Flex minH="100vh" align="center" justify="center" bg="gray.50">

        <Box
          bg="white"
          p={6}
          rounded="md"
          shadow="2xl"
          w="full"
          maxW="sm"
          textAlign="center"
          position="relative"
        >
          <Flex justify="center" mb={8}>
            <Avatar
              size="xl"
              src="/assets/images/aajaalogo.png" // Replace with actual image path
              boxSize="120px" // Custom size
              border="4px solid white"
              bg="#e7dddd"
              boxShadow="md"
              position="absolute"
              top="-60px"
              left="50%"
              transform="translateX(-50%)"
            />
          </Flex>

          {showBlock ? (
            <Box>
              <form onSubmit={handleOTP}>
                <VStack spacing={4}>
                  <FormControl >
                    <FormLabel fontSize={{ base: "sm", md: "md" }}>OTP</FormLabel>
                    <Input
                      type="number"
                      placeholder="OTP"
                      size='sm'
                      maxLength={4}
                      value={otp} // value is set here
                      onChange={(e) => setOTP(e.target.value)} // updates state
                    />
                    {otpErrors && (<FormErrorMessage>{otpErrors}</FormErrorMessage>)}
                  </FormControl>

                  <Stack spacing={4} direction='row' align='center'>
                    <Button
                      colorScheme="red"
                      type="submit"
                      fontSize={{ base: "sm", md: "md" }}
                      size='sm'
                    >
                      Verify OTP
                    </Button>

                    <Button
                      colorScheme="green"
                      type="button"
                      fontSize={{ base: "sm", md: "md" }}
                      size='sm'
                      onClick={resendOTP}
                    >
                      Resend OTP
                    </Button>
                  </Stack>

                </VStack>
              </form>
            </Box>
          ) : (

            <>
              <form onSubmit={handleSubmit(onSubmit)}>
                <VStack spacing={4}>
                  <FormControl isInvalid={!!errors.MobileNo}>
                    <FormLabel fontSize={{ base: "sm", md: "md" }}>Mobile</FormLabel>
                    <Input
                      type="text"
                      placeholder="Mobile"
                      {...register("MobileNo")}
                      size='sm'
                    />
                    <FormErrorMessage>{errors.MobileNo?.message}</FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={!!errors.password}>
                    <FormLabel fontSize={{ base: "sm", md: "md" }}>Password</FormLabel>
                    <Input
                      type="password"
                      placeholder="Password"
                      {...register("password")}
                      size='sm'
                    />
                    <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
                  </FormControl>

                  <Button
                    colorScheme="teal"
                    type="submit"
                    width="full"
                    fontSize={{ base: "sm", md: "md" }}
                    size='sm'
                  >
                    Login
                  </Button>
                </VStack>
              </form>

              <Box mt={4} textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                <Text fontSize="sm" mt={4}>
                  Don't have an account?{' '}
                  <Link as={RouterLink} to="/signup" color="red.500" fontWeight="semibold">
                    Sign Up
                  </Link>
                </Text>
                <Text fontSize="sm">
                  <Link as={RouterLink} to="/forgot-password" color="blue.500" fontWeight="semibold">
                    Forgot your password?
                  </Link>
                </Text>
              </Box>

            </>

          )}

        </Box>      
      

    </Flex>
  );
};

export default AdminLogin;
